import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "./Card";
import Pagination from "./Pagination";

export default function SearchResults() {
  const location = useLocation();
  const navigate = useNavigate();
  const [cars, setCars] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  const limit = 15;


  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page")) || 1;
    setPage(pageParam);
  }, [location.search]);

  useEffect(() => {
    const fetchCars = async () => {
      setLoading(true);

      const query = new URLSearchParams(location.search);
      query.set("limit", limit);

      const res = await axios.get(
        `https://automotive-backend-production.up.railway.app/inventory/search?${query.toString()}`
      );

      const { cars, totalCount } = res.data;
      setCars(Array.isArray(cars) ? cars : []);
      setTotalCount(totalCount || 0);
      setLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    fetchCars();
  }, [location.search]);

  const handlePageChange = (newPage) => {
    const params = new URLSearchParams(location.search);
    params.set("page", newPage);
    navigate(`/search?${params.toString()}`);
  };

  if (loading) return <div className="text-center my-5">Loading...</div>;
  if (cars.length === 0) return <div className="text-center my-5">No cars found</div>;

  return (
    <div className="container my-4">
      <h4 className="fw-bold mb-3">Search Results ({totalCount})</h4>
      <div className="row g-3">
        {cars.map((car) => (
          <div className="col-md-4" key={car.RecordNumber}>
            <Card
              RecordNumber={car.RecordNumber} 
              title={car.Name}
              image={`https://automotive-backend-production.up.railway.app/${car.ImageURL?.[0]}`}
              price={car.Price}
              year={car.Year}
              transmission={car.Transmission}
              fuel={car.FuelType}
              km={car.Mileage}
            />
          </div>
        ))}
      </div>

      <Pagination
        page={page}
        onPageChange={handlePageChange}
        totalCount={totalCount}
        limit={limit}
      />
    </div>
  );
}
